/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { forEach, identity, keys, startsWith } from 'lodash';


function handleReportsAudits(rawPath: string, partialPath: string): string {
  let path = rawPath;
  if (path === "/reports/audits/active" || path === "/reports/audits/completed") {
      return path + "/summary";
  }
  const regExp = /(\/reports\/audits\/[active|draft|completed]+\/)(\d+)\/(.*)/;
  let groups = path.match(regExp);
  if (groups && groups.length === 4) {
    if (groups[3] === '') {
      groups[3] = 'summary';
    }
    return groups[1] + 'auditId/' + groups[3];
  }
  return path;
}

function handleTodoList(rawPath: string, partialPath: string): string {
  return partialPath;
}

const GROUPS = {
  '/sor/listing': identity,
  '/todo_list': handleTodoList,
  '/reports/audits': handleReportsAudits,
};

export function handlePath(rawPath: string): string {
  let resultPath: string|undefined = rawPath;
  forEach(GROUPS, (pathFn, partialPath) => {
    if (rawPath.includes(partialPath)) {
      resultPath = pathFn(rawPath, partialPath);
    }
  });
  return resultPath;
}

export function shouldSendTrace(rawPath: string): boolean {
  return keys(GROUPS).some(urlPrefix => startsWith(rawPath, urlPrefix));
}
